export default __webpack_public_path__ + "static/media/device.ee4c1151.svg";